import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { ServerTypes } from 'src/app/models/servers';
import { Task } from 'src/app/interfaces/task';
import { requests } from 'src/app/models/requests';

@Injectable()
export class DashboardService {
  constructor(private http: HttpClient, private apiService: ApiService) {}

  private get url(): string {
    return this.apiService.getCurentServer(ServerTypes.boapi);
  }

  public getChartData(dataUrl: string): Observable<any> {
    return this.http.get(this.url + dataUrl);
  }

  public getTasks(): Observable<Task[]> {
    return this.http.get<Task[]>(this.url + requests.getTasks);
  }
}
